import { Activity } from 'react';
import Paging from '@ui/paging/paging';
import CustomSelect from '@ui/select/custom-select/custom-select';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from '../../utils';

interface ProfileTableFooterProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: '10' | '25' | '50' | '100') => void;
  selectId: string;
}

const ProfileTableFooter = ({
  page,
  totalPages,
  onPageChange,
  onPageSizeChange,
  selectId,
}: ProfileTableFooterProps) => (
  <Container className="flex ai-center jc-space-between padding-v-16" background="var(--BG)">
    <Container minWidth="0px">
      <Activity mode={totalPages > 1 ? 'visible' : 'hidden'}>
        <Paging page={page} totalPages={totalPages} setPage={onPageChange} />
      </Activity>
    </Container>
    <Container width="175px">
      <CustomSelect
        labelHeight="32px"
        hideHeader
        id={selectId}
        Placeholder="Show"
        onChange={(options) => onPageSizeChange(options[0]?.value as '10' | '25' | '50' | '100')}
        defaultOptions={DEFAULT_PAGE_SIZE}
        options={PAGE_SIZE_OPTIONS}
        permanentDropdownIcon
        dynamicMenuPlacement
        isSearchable={false}
        isMultiSelect={false}
        hidePlaceholderIfInputHasValue={false}
        hidePlaceholderOnInputFocus={false}
        RenderUnfocusedLabelContent={({ option }) => (
          <Container className="flex fd-row fa-center ai-center gap-8" height="32px">
            <Text design="GlobalIcoText3">Show:</Text>
            <Text design="GlobalIcoText1">{option.label}</Text>
          </Container>
        )}
        RenderFocusedLabelContent={({ option }) => (
          <Container className="flex fd-row fa-center ai-center gap-8" height="32px">
            <Text design="GlobalIcoText3">Show:</Text>
            <Text design="GlobalIcoText1">{option.label}</Text>
          </Container>
        )}
      />
    </Container>
  </Container>
);

export default ProfileTableFooter;
